/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useIconicSubscriptionInfo = (
  iconicGoalKey,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = `subscription-info/${iconicGoalKey}`;

  const {
    data: iconicSubscriptionInfo,
    isValidating,
    ...rest
  } = useFetch(
    iconicGoalKey && key ? key : null,
    { hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(iconicSubscriptionInfo || {});
  return {
    key,
    iconicSubscriptionInfo,
    isValidating,
    ...rest
  };
};

export default useIconicSubscriptionInfo;
